










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { DataSource } from '@/types';
import { TableConfig, TableColumn, TableComponent } from '@/core/components/table';
import { CONTRACTS, WindowsServiceContract } from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { date } from '@/core/filters';

@Component({
    components: {
        TableComponent
    }
})
export default class ConsumptionsEditTable extends Vue {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: [Array, Object], required: true })
    public dataSource!: DataSource;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;

    public get columns(): TableColumn[] {
        return [
            {
                dataField: 'ObjectCode',
                caption: 'GridColumnTitleObjectCode',
                allowEditing: true,
                showEditorAlways: true
            },
            {
                dataField: 'OrderNumber',
                caption: 'GridColumnTitleOrderNumber',
                allowEditing: true,
                showEditorAlways: true
            },
            {
                dataField: 'PlanCode',
                caption: 'GridColumnTitlePlanCode',
                allowEditing: true,
                showEditorAlways: true
            },
            {
                dataField: 'Quantity',
                caption: 'GridColumnTitleSAPQuantity',
                allowEditing: true,
                showEditorAlways: true
            },
            {
                dataField: 'State.Finish',
                caption: 'GridColumnTitleSAPTime',
                allowEditing: true,
                showEditorAlways: true,
                setCellValue: (rowData, value) =>
                    (rowData.State_Finish = value),
                calculateCellValue: (pack: any) =>
                    date(pack.State.Finish as string, false)
            }
        ];
    }

    public get tableConfig(): Partial<TableConfig> {
        return {
            editing: {
                allowDeleting: false,
                allowUpdating: true,
                allowAdding: false,
                useIcons: true,
                mode: 'batch'
            },
            selection: {
                mode: 'single'
            }
        };
    }
}
